// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Importacion paleta de colores */
:root {
  --text-light:#9E9E9E;
  --text-medium:#4D4D4D;
  --text-dark:#0F0F0F;
  --text-heading: #001733;
  --text-link: #0F69B4;
  --primary-00: #0F69B4;
  --primary-10: #F2F8FF;
  --primary-20: #D6E9FF;
  --primary-40: #66A7EB;
  --primary-60: #093F6C;
  --primary-80: #001733;
  --secondary-00: #E22C2C;
  --secondary-20: #FFCCCC;
  --secondary-40: #FF6666;
  --secondary-80: #330000;
  --background-primary: #FEFDFD;
  --background-secondary: #0D223F;
  --icon-light:#9E9E9E;
  --icon-dark:#0F69B4;
  --neutral-00: #FFFFFF;
  --neutral-05: #EFEFEF;
  --neutral-10: #DFDFDF;
  --neutral-20: #BEBEBE;
  --neutral-40: #9E9E9E;
  --neutral-60: #4D4D4D;
  --neutral-80: #0F0F0F;
  --success-light: #EFF8EF;
  --success-medium: #92DF92;
  --success-dark: #5CB85C;
  --success-opacitie: #5CB85C 20%;
  --error-light: #FBEEED;
  --error-medium: #F98885;
  --error-dark: #D9534F;
  --error-opacitie: #D9534F 20%;
  --warning-light: #FFF6E8;
  --warning-medium: #FFCB66;
  --warning-dark: #FFA11B;
  --warning-opacitie: #FFA11B 20%;
  --information-light: #EFF9FC;
  --information-medium: #8DE2FB;
  --information-dark: #5BC0DE;
  --information-opacitie: #5BC0DE 20%;
  --dark-05:#0000000D;
  --dark-10:#0000001A;
  --dark-20:#00000033;
  --dark-40:#00000066;
  --dark-80:#000000CC;
  --light-05:#FFFFFF0D;
  --light-10:#FFFFFF1A;
  --light-20:#FFFFFF33;
  --light-40:#FFFFFF66;
  --light-80:#FFFFFFCC;
  --shadow-soft: 0px 2px 2px 0px rgba(77, 77, 77, 0.15);
  --shadow-medium: 0px 4px 8px 0px rgba(77, 77, 77, 0.15);
  --shadow-strong: 0px 8px 16px 0px rgba(77, 77, 77, 0.15);
}

.custom-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  font-weight: bold;
  border-radius: 4px;
  gap: 8px;
  height: 40px;
  transition: background-color 0.3s;
  outline: none;
}

.custom-button.only-text {
  padding: 0px 24px 0px 24px;
}
.custom-button.only-icon {
  width: 40px !important;
  padding: 0px;
}
.custom-button.has-suffix {
  padding: 8px 8px 8px 24px;
  justify-content: center;
}
.custom-button.has-prefix {
  padding: 8px 24px 8px 8px;
  justify-content: center;
}

.custom-button.filled {
  background-color: var(--primary-00);
  color: var(--neutral-00);
}
.custom-button.filled svg path {
  fill: var(--neutral-00);
}

.custom-button.filled:hover {
  background-color: var(--primary-60);
  color: var(--neutral-00) !important;
}
.custom-button.filled:hover svg path {
  fill: var(--neutral-00);
}

.custom-button.filled:active {
  background-color: var(--primary-40);
  color: var(--neutral-00) !important;
  box-shadow: inset 0 0 0 1px var(--primary-40);
}
.custom-button.filled:active svg path {
  fill: var(--neutral-00);
}

.custom-button.filled:focus {
  box-shadow: inset 0 0 0 2px var(--primary-40);
}

.custom-button.filled:disabled {
  background-color: var(--dark-10) !important;
  color: var(--text-light) !important;
  border: none;
  cursor: not-allowed;
}
.custom-button.filled:disabled svg path {
  fill: var(--text-light);
}
.custom-button.filled:disabled:active {
  box-shadow: none !important;
}

.custom-button.outlined {
  background-color: var(--neutral-00);
  color: var(--primary-00);
  box-shadow: inset 0 0 0 1px var(--primary-00);
}
.custom-button.outlined svg path {
  fill: var(--primary-00);
}

.custom-button.outlined:hover {
  background-color: var(--primary-20);
  color: var(--primary-00) !important;
  box-shadow: inset 0 0 0 1px var(--primary-00);
}
.custom-button.outlined:hover svg path {
  fill: var(--primary-00);
}

.custom-button.outlined:active {
  background-color: var(--primary-40);
  color: var(--neutral-00) !important;
  box-shadow: inset 0 0 0 1px var(--primary-40);
}
.custom-button.outlined:active svg path {
  fill: var(--neutral-00) !important;
}

.custom-button.outlined:focus {
  box-shadow: inset 0 0 0 2px var(--primary-40);
}

.custom-button.outlined:disabled {
  background-color: var(--neutral-00);
  color: var(--dark-40);
  box-shadow: inset 0 0 0 1px var(--dark-40);
  cursor: not-allowed;
}
.custom-button.outlined:disabled svg path {
  fill: var(--dark-40);
}
.custom-button.outlined:disabled:hover {
  color: var(--dark-40) !important;
}
.custom-button.outlined:disabled:active {
  color: var(--dark-40) !important;
}
.custom-button.outlined:disabled:active svg path {
  fill: var(--dark-40) !important;
}

.custom-button.text {
  background-color: var(--neutral-00);
  color: var(--primary-00);
  box-shadow: none;
  border: none;
}
.custom-button.text svg path {
  fill: var(--primary-00);
}

.custom-button.text:hover {
  background-color: var(--primary-20);
  color: var(--primary-00) !important;
  border: none;
}
.custom-button.text:hover svg path {
  fill: var(--primary-00);
}

.custom-button.text:active {
  background-color: var(--primary-40);
  color: var(--neutral-00) !important;
  border: none;
}
.custom-button.text:active svg path {
  fill: var(--neutral-00);
}

.custom-button.text:focus {
  box-shadow: inset 0 0 0 2px var(--primary-40);
}

.custom-button.text:disabled {
  background-color: var(--neutral-00);
  color: var(--dark-40);
  box-shadow: none !important;
  cursor: not-allowed;
}
.custom-button.text:disabled svg path {
  fill: var(--dark-40);
}
.custom-button.text:disabled:hover {
  color: var(--dark-40) !important;
}
.custom-button.text:disabled:active {
  color: var(--dark-40) !important;
  box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Genericos/CustomButton/CustomButton.scss","webpack://./src/styles/paleta-colores.scss"],"names":[],"mappings":"AAAA,kCAAA;ACAA;EAEI,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EAGA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EAGA,6BAAA;EACA,+BAAA;EAGA,oBAAA;EACA,mBAAA;EAGA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,wBAAA;EACA,yBAAA;EACA,uBAAA;EACA,+BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,uBAAA;EACA,+BAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,mCAAA;EAGA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAIA,qDAAA;EACA,uDAAA;EACA,wDAAA;ADhBJ;;AAtDA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,iCAAA;EACA,aAAA;AAyDJ;;AAnDI;EACE,0BAAA;AAsDN;AApDI;EACI,sBAAA;EACA,YAAA;AAsDR;AAnDI;EACI,yBAAA;EACA,uBAAA;AAqDR;AAlDI;EACE,yBAAA;EACA,uBAAA;AAoDN;;AA5CE;EACE,mCAAA;EACA,wBAAA;AA+CJ;AA9CI;EACE,uBAAA;AAgDN;;AA5CE;EACE,mCAAA;EACA,mCAAA;AA+CJ;AA9CI;EACE,uBAAA;AAgDN;;AA5CE;EACE,mCAAA;EACA,mCAAA;EACA,6CAAA;AA+CJ;AA9CI;EACE,uBAAA;AAgDN;;AA5CE;EACE,6CAAA;AA+CJ;;AA5CE;EAEE,2CAAA;EACA,mCAAA;EACA,YAAA;EAIA,mBAAA;AA2CJ;AA9CI;EACE,uBAAA;AAgDN;AA5CI;EACE,2BAAA;AA8CN;;AAxCE;EACE,mCAAA;EACA,wBAAA;EACA,6CAAA;AA2CJ;AA1CI;EACE,uBAAA;AA4CN;;AAxCE;EACE,mCAAA;EACA,mCAAA;EACA,6CAAA;AA2CJ;AA1CI;EACE,uBAAA;AA4CN;;AAxCE;EACE,mCAAA;EACA,mCAAA;EACA,6CAAA;AA2CJ;AA1CI;EACE,kCAAA;AA4CN;;AAxCE;EACE,6CAAA;AA2CJ;;AAxCE;EACE,mCAAA;EACA,qBAAA;EACA,0CAAA;EAIA,mBAAA;AAwCJ;AA3CI;EACE,oBAAA;AA6CN;AA1CI;EACE,gCAAA;AA4CN;AAzCI;EACE,gCAAA;AA2CN;AA1CM;EACE,+BAAA;AA4CR;;AApCE;EACE,mCAAA;EACA,wBAAA;EAIA,gBAAA;EACA,YAAA;AAoCJ;AAxCI;EACE,uBAAA;AA0CN;;AApCE;EACE,mCAAA;EACA,mCAAA;EAIA,YAAA;AAoCJ;AAvCI;EACE,uBAAA;AAyCN;;AApCE;EACE,mCAAA;EACA,mCAAA;EACA,YAAA;AAuCJ;AAtCI;EACE,uBAAA;AAwCN;;AApCE;EACE,6CAAA;AAuCJ;;AApCE;EACE,mCAAA;EACA,qBAAA;EACA,2BAAA;EAIA,mBAAA;AAoCJ;AAvCI;EACE,oBAAA;AAyCN;AArCI;EACE,gCAAA;AAuCN;AApCI;EACE,gCAAA;EACA,2BAAA;AAsCN","sourcesContent":["/* Importacion paleta de colores */\n@import \"../../../styles/paleta-colores.scss\";\n\n.custom-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    cursor: pointer;\n    font-weight: bold;\n    border-radius: 4px;\n    gap: 8px;\n    height: 40px;\n    transition: background-color 0.3s;\n    outline: none;\n\n  }\n\n  //TAMAÑOS\n  .custom-button {\n    &.only-text{\n      padding: 0px 24px 0px 24px;\n    }\n    &.only-icon {\n        width: 40px !important;\n        padding: 0px;\n    }\n\n    &.has-suffix {\n        padding: 8px 8px 8px 24px;\n        justify-content: center;\n    }\n    \n    &.has-prefix {\n      padding: 8px 24px 8px 8px;\n      justify-content: center;\n    }\n  }\n\n  //FIN TAMAÑOS\n  \n  // COLORES BOTON PRIMARIO\n  \n  .custom-button.filled {\n    background-color: var(--primary-00);\n    color: var(--neutral-00);\n    svg path {\n      fill: var(--neutral-00); \n    }\n  }\n  \n  .custom-button.filled:hover {\n    background-color: var(--primary-60);\n    color: var(--neutral-00) !important;\n    svg path {\n      fill: var(--neutral-00); \n    }\n  }\n  \n  .custom-button.filled:active {\n    background-color: var(--primary-40);\n    color: var(--neutral-00) !important;\n    box-shadow: inset 0 0 0 1px var(--primary-40);\n    svg path {\n      fill: var(--neutral-00); \n    }\n  }\n  \n  .custom-button.filled:focus {\n    box-shadow: inset 0 0 0 2px var(--primary-40);\n  }\n  \n  .custom-button.filled:disabled {\n\n    background-color: var(--dark-10) !important;\n    color: var(--text-light) !important;\n    border: none;\n    svg path {\n      fill: var(--text-light); \n    }\n    cursor: not-allowed;\n\n    &:active {\n      box-shadow: none !important;\n    }\n  }\n  \n  //COLOR BOTON SECUNDARIO\n\n  .custom-button.outlined {\n    background-color: var(--neutral-00);\n    color: var(--primary-00) ;\n    box-shadow: inset 0 0 0 1px var(--primary-00);\n    svg path {\n      fill: var(--primary-00); \n    }\n  }\n  \n  .custom-button.outlined:hover {\n    background-color: var(--primary-20);\n    color: var(--primary-00) !important;\n    box-shadow: inset 0 0 0 1px var(--primary-00);\n    svg path {\n      fill: var(--primary-00); \n    }\n  }\n  \n  .custom-button.outlined:active {\n    background-color: var(--primary-40);\n    color: var(--neutral-00) !important;\n    box-shadow: inset 0 0 0 1px var(--primary-40);\n    svg path {\n      fill: var(--neutral-00) !important; \n    }\n  }\n  \n  .custom-button.outlined:focus {\n    box-shadow: inset 0 0 0 2px var(--primary-40);\n  }\n  \n  .custom-button.outlined:disabled {\n    background-color: var(--neutral-00);\n    color: var((--dark-40));\n    box-shadow: inset 0 0 0 1px var(--dark-40);\n    svg path {\n      fill: var((--dark-40)); \n    }\n    cursor: not-allowed;\n    &:hover {\n      color: var(--dark-40) !important; \n    }\n\n    &:active {\n      color: var(--dark-40) !important; \n      svg path {\n        fill: var((--dark-40)) !important; \n      }\n    }\n\n  }\n  \n  //COLOR BOTON TERCIARIO\n\n  .custom-button.text {\n    background-color: var(--neutral-00);\n    color: var(--primary-00);\n    svg path {\n      fill: var(--primary-00); \n    }\n    box-shadow: none;\n    border: none;\n  }\n  \n  .custom-button.text:hover {\n    background-color: var(--primary-20);\n    color: var(--primary-00) !important;\n    svg path {\n      fill: var(--primary-00); \n    }\n    border: none;\n  }\n  \n  .custom-button.text:active {\n    background-color: var(--primary-40);\n    color: var(--neutral-00) !important;\n    border: none;\n    svg path {\n      fill: var(--neutral-00) ; \n    }\n  }\n  \n  .custom-button.text:focus {\n    box-shadow: inset 0 0 0 2px var(--primary-40);\n  }\n  \n  .custom-button.text:disabled {\n    background-color: var(--neutral-00);\n    color: var((--dark-40));\n    box-shadow: none !important;\n    svg path {\n      fill: var((--dark-40)); \n    }\n    cursor: not-allowed;\n\n    &:hover {\n      color: var((--dark-40)) !important;\n    }\n\n    &:active {\n      color: var((--dark-40)) !important;\n      box-shadow: none !important;\n    }\n  }\n  ",":root {\n    //Texts\n    --text-light:#9E9E9E;\n    --text-medium:#4D4D4D;\n    --text-dark:#0F0F0F;\n    --text-heading: #001733;\n    --text-link: #0F69B4;\n\n    //main colors\n    --primary-00: #0F69B4;\n    --primary-10: #F2F8FF;\n    --primary-20: #D6E9FF;\n    --primary-40: #66A7EB;\n    --primary-60: #093F6C;\n    --primary-80: #001733;\n\n    //secondary colors\n    --secondary-00: #E22C2C;\n    --secondary-20: #FFCCCC;\n    --secondary-40: #FF6666;\n    --secondary-80: #330000;\n\n    //background colors\n    --background-primary: #FEFDFD;\n    --background-secondary: #0D223F;\n\n    //icons\n    --icon-light:#9E9E9E;\n    --icon-dark:#0F69B4;\n\n    //neutral colors\n    --neutral-00: #FFFFFF;\n    --neutral-05: #EFEFEF;\n    --neutral-10: #DFDFDF;\n    --neutral-20: #BEBEBE;\n    --neutral-40: #9E9E9E;\n    --neutral-60: #4D4D4D;\n    --neutral-80: #0F0F0F;\n\n    //Feedback colors\n    --success-light: #EFF8EF;\n    --success-medium: #92DF92;\n    --success-dark: #5CB85C;\n    --success-opacitie: #5CB85C 20%;\n    --error-light: #FBEEED;\n    --error-medium: #F98885;\n    --error-dark: #D9534F;\n    --error-opacitie: #D9534F 20%;\n    --warning-light: #FFF6E8;\n    --warning-medium: #FFCB66;\n    --warning-dark: #FFA11B;\n    --warning-opacitie: #FFA11B 20%;\n    --information-light: #EFF9FC;\n    --information-medium: #8DE2FB;\n    --information-dark: #5BC0DE;\n    --information-opacitie: #5BC0DE 20%;\n\n    //Opacities\n    --dark-05:#0000000D;\n    --dark-10:#0000001A;\n    --dark-20:#00000033;\n    --dark-40:#00000066;\n    --dark-80:#000000CC;\n    --light-05:#FFFFFF0D;\n    --light-10:#FFFFFF1A;\n    --light-20:#FFFFFF33;\n    --light-40:#FFFFFF66;\n    --light-80:#FFFFFFCC;\n\n\n    //Shadows\n    --shadow-soft: 0px 2px 2px 0px rgba(77, 77, 77, 0.15);\n    --shadow-medium: 0px 4px 8px 0px rgba(77, 77, 77, 0.15);\n    --shadow-strong: 0px 8px 16px 0px rgba(77, 77, 77, 0.15);\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
